module.exports = __webpack_public_path__ + "img/qhjbh_title.54d3264e.png";